export const getIncidencesInitialState = {
	incidences: null,
	error: null,
	errorShow: false,
	loading: false,
};
